import { useQueryClient } from '@tanstack/react-query';
import { DateFormatter } from 'infrastructure/functions';

import useApi from '../use-api';
import { getPatientInfoKey } from './use-patient-info';

import type { IPatient } from 'infrastructure/interfaces';

const api = `core-2/patients/consent-form-date`;

export const useUpdateConsentDate = () => {
  const { loading, updateData } = useApi();

  const queryClient = useQueryClient();

  const update = async (
    patientGuid: string,
    consentDate: Date,
  ): Promise<void> => {
    await updateData<IPatient>(api, {
      patientGuid,
      signedDate: DateFormatter({ date: consentDate }),
    });
    queryClient.invalidateQueries(getPatientInfoKey(patientGuid));
  };

  return {
    loading,
    update,
  };
};
